export const CSpinner = {
    PATH: "./assets/animations/ModakLoader.json",
    ELLIPSE_PATH: "./assets/animations/EllipseLoader.json"
} as const